import ErrorComponent from 'Components/ErrorComponent';
import TableLoading from 'Components/TableLoading';
import { Get } from 'VesselMaster/vesselMaster.hooks';
import React from 'react'
import { useQuery } from 'react-query';
import { Button, Card, CardBody, CardHeader, Col, Modal, Row } from 'reactstrap';
import { queryKeyes } from 'shared/queryKeys';
import STSAdjustmentTable from './STSAdjustmentTable';

interface STSAdjustmentPopupType {
    state: boolean,
    setState: any,
    toggle: any,
    event: any,
    target: string,
}

const STSAdjustmentPopup = ({
    state,
    setState,
    toggle,
    event,
    target,
}: STSAdjustmentPopupType) => {
    /** Queries */
    /** Vessel specific voyages */
    const { data: STSApproval, isLoading: STSApprovalLoading, isError: STSApprovalError } = useQuery(
        [queryKeyes.vessel.STSAdjustmentApprovalData.key, event?.id],
        async () => {
            return await Get(queryKeyes.vessel.STSAdjustmentApprovalData.url(event?.id), event?.id);
        },
        { staleTime: Infinity }
    )
    /** Queries end */
    return (
        <Modal
            isOpen={state}
            toggle={() => {
                toggle();
            }}
            backdrop={"static"}
            id={target}
            size='xl'
        >
            <div className="modal-header p-2">
                <h5 className="modal-title" id="staticBackdropLabel">
                    Select applicable STS Adjustment events
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                        setState(false);
                    }}
                    aria-label="Close"
                />
            </div>
            <div className="modal-body">
                {STSApprovalLoading && <TableLoading />}
                {STSApprovalError && <ErrorComponent message='Error loading required data!' />}
                {(!STSApprovalLoading && !STSApprovalError) &&
                    <React.Fragment>
                        <Card className='mb-3'>
                            <CardHeader className='p-2'>
                                <h5 className='mb-0'>Voyage Pre STS Operation</h5>
                            </CardHeader>
                            <CardBody className='p-0'>
                                <STSAdjustmentTable STSApproval={STSApproval?.pre_sts} op="pre_sts" />
                            </CardBody>
                        </Card>
                        <Card className='mb-3'>
                            <CardHeader className='p-2'>
                                <h5 className='mb-0'>STS Operation</h5>
                            </CardHeader>
                            <CardBody className='p-0'>
                                <STSAdjustmentTable STSApproval={STSApproval?.sts_operation} op="sts_operation" />
                            </CardBody>
                        </Card>
                        <Card className='mb-3'>
                            <CardHeader className='p-2'>
                                <h5 className='mb-0'>Voyage Post STS Operation</h5>
                            </CardHeader>
                            <CardBody className='p-0'>
                                <STSAdjustmentTable STSApproval={STSApproval?.post_sts} op="post_sts" />
                            </CardBody>
                        </Card>
                        <Row>
                            <Col lg={{ size: 2, offset: 10 }}>
                                <Button type='button' className='btn justify_right' color='primary'>Approve</Button>
                            </Col>
                        </Row>
                    </React.Fragment>
                }
            </div>
        </Modal >
    )
}

export default STSAdjustmentPopup